import ItemCategoryForm from "components/ItemCategory/form"
import WarehouseForm from "components/Warehouse/form"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { storeItemCategory } from "store/item-category/item-category-action"
import { getAllCommodityClassifications } from "store/general-renders/general-action"

const AddItemCategory = () => {
  document.title = "Add Item Category"

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error } = useSelector(state => state.itemCategory)
  const commodityClassifications = useSelector(
    state => state.generalRenders.commodityClassifications
  )
  const commodityClassificationLoading = useSelector(
    state => state.generalRenders.commodityClassificationLoading
  )

  useEffect(() => {
    dispatch(getAllCommodityClassifications())
  }, [dispatch])

  /*
  onSubmit:
  - handleSubmit: Triggered when the form is submitted
  - values: Contains the form input values
  - Dispatches the action to store the Item Category with the provided values
  */
  const handleSubmit = values => {
    dispatch(storeItemCategory(values, navigate))
  }

  return (
    <ItemCategoryForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Add"}
      commodityClassifications={commodityClassifications}
      commodityClassificationLoading={commodityClassificationLoading}
    />
  )
}

export default AddItemCategory
